export default {
	headers: {
		financialFiles: 'Expediente financiero',
		user: 'Usuaria',
		actions: 'Cambiar',
		changeType: 'Tipo de cambio',
		date: 'Fecha',
		description: 'Descripción'
	},
	label: {
		logType: 'Tipo de registro',
		user: 'Usuario',
		fromDate: 'Desde la fecha',
		toDate: 'Hasta la fecha'
	},

	accounts: 'Cuentas',
	accounting: 'Contabilidad',
	currencies: 'Monedas',
	'financial-file': 'Expediente financiero',
	'fund-flow': 'Flujo de fondos',
	manufacturing: 'Fabricación',
	'material-flow': 'Flujo de materiales',
	'material-warehouse': 'Almacén de materiales',
	users: 'Usuarios',


	fetch: 'Lectura',
	create: 'Actualizar',
	update: 'Crear',
	edit: 'Editar',
	delete: 'Borrar',
	post: 'Deportación',
	unPost: 'Cancelar la deportación',

	search: 'Buscar',

	'full-log-types': {
		'financial-flies': 'Financial Files',
		accounts: 'Accounts',
		'contact-infos': 'Contact Infos',
		'financial-file-config': 'Financial File Configuration',
		currencies: 'Currencies',
		'custom-statements': 'Custom Statements',
		'receipt-bonds': 'Receipt Bonds',
		'payment-bonds': 'Payment Bonds',
		'cash-entries': 'Cash Entries',
		'accounting-entries': 'Accounting Entries',
		'cash-bonds': 'Cash Bonds',
		'accounting-bonds': 'Accounting Bonds',
		'receipt-entries': 'Receipt Entries',
		'payment-entries': 'Payment Entries',
		'sub-invoices': 'Sub Invoices',
		'buy-invoices': 'Buy Invoices',
		'buy-refund-invoices': 'Buy Refund Invoices',
		'sale-refund-invoices': 'Sale Refund Invoices',
		'buy-material-entries': 'Buy Material Entries',
		'sale-material-entries': 'Sale Material Entries',
		'buy-refund-material-entries': 'Buy Refund Material Entries',
		'sale-refund-material-entries': 'Sale Refund Material Entries',
		roles: 'Roles',
		users: 'Users',
		'transaction-bonds': 'Transaction Bonds',
		'transaction-entries': 'Transaction Entries',
		'manufacturing-files': 'Manufacturing Files',
		'manufacturing-file-entries': 'Manufacturing File Entries',
		'manufacturing-file-entry-raw-materials': 'Manufacturing File Entry Raw Materials',
		'material-journals': 'Material Journals',
		'material-entries': 'Material Entries',
		'receipt-invoice-transactions': 'Receipt Invoices Transactions',
		'payment-invoice-transaction': 'Payment Invoices Transaction',
		'expenses-buy-invoice-transaction': 'Expenses Buy Invoice Transaction',
		'expenses-sale-invoice-transaction': 'Expenses Sale Invoice Transaction',
		materials: 'Materials',
		'linked-materials': 'Linked Materials',
		'unit-sizes': 'Unit Sizes',
		warehouses: 'Warehouses',
		'delivery-statuses': 'estados de entrega',
		'invoice-transactions': 'transacciones de facturas'
	}
}